module.exports = __webpack_public_path__ + "media/homepage/header-collage@4x-e7fc49c4.png";